import { Toaster } from '../toaster'

let _instance = null;

export function loadToast(instance, id, options) {
  const toastItem = document.createElement('div')
  const toasterSlot = document.querySelector('.toaster-slot')
  toasterSlot.appendChild(toastItem)
  const toast = document
  toast.$mount(toastItem)
}

export function makeToast(instance, message, options) {
  // share the instance across
  _instance = instance;

  options = parseOptions(options);

  const newToast = createToast(instance, message, options);
  return toastObject(newToast, _instance);
}


export const createToast = function (instance, html, options) {
  const toast = new Toaster({
    propsData: {
      ...options,
      content: html,
      instance,
    },
  })
  const toastItem = document.createElement('div')
  const toasterSlot = document.querySelector('.toaster.toaster-root .toaster-slot')
  toasterSlot.appendChild(toastItem)
  toast.$mount(toastItem)

  return toast
}

export function parseOptions(options) {
  const parseOptions = {
    position: 'top-right',
    colour: 'green',
    className: '',
    title: '',
    noCloseButton: '',
    containerClass: '',
    timer: false,
    ...options,
  }

  if (parseOptions.containerClass && typeof(parseOptions.containerClass) === 'string') {
    parseOptions.containerClass = parseOptions.containerClass.split(' ');
  }

  if (!parseOptions.containerClass) {
    parseOptions.containerClass = [];
  }

  return parseOptions
}

// change the text of toast
export const changeText = (el, text) => {
  if (typeof HTMLElement === "object" ? text instanceof HTMLElement : text && typeof text === "object" && text !== null && text.nodeType === 1 && typeof text.nodeName === "string"
  ) {
    el.appendChild(text);
  }
  else {
    el.innerHTML = text;
  }

  return this;
};

export const toastObject = function (el, instance) {
  let disposed = false;

  return {
    el: el,
    text: function (text) {
      changeText(el, text);
      return this;
    },
    goAway: function (delay = 800) {
      disposed = true;
      // todo  animation goAway
    },
    remove : function () {
      instance.remove(el);
    },
    disposed : function () {
      return disposed
    }
  };
}


export const generateUuid = (() => {
  if (window &&
      window.crypto &&
      (typeof window.crypto.randomUUID === "function")
  ){
    return window.crypto.randomUUID()
  }
  // Should never enter here as only i.e. doesn't support this api
  // https://developer.mozilla.org/en-US/docs/Web/API/Crypto/randomUUID
  console.warn(`Using a legacy browser that doesn't support window cryptographic API`)
  const d = new Date().getTime()
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16
    if(d > 0){
      r = (d + r)%16 | 0
    }
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
});
